var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agents" },
    [
      _c(
        "div",
        { staticClass: "main-wrapper" },
        [
          _c("layout-header"),
          _vm._v(" "),
          _c("layout-sidebar"),
          _vm._v(" "),
          _c("div", { staticClass: "page-wrapper" }, [
            _c("div", { staticClass: "content container-fluid" }, [
              _c("div", { staticClass: "page-header" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "page-title" }, [_vm._v("Agent")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "breadcrumb" }, [
                      _c(
                        "li",
                        { staticClass: "breadcrumb-item" },
                        [
                          _c("router-link", { attrs: { to: "/index" } }, [
                            _vm._v("Dashboard")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("li", { staticClass: "breadcrumb-item active" }, [
                        _vm._v("Agent")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto float-end ms-auto" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "javascript:void(0)",
                          "data-toggle": "modal",
                          "data-target": "#add_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcast(true)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus" }),
                        _vm._v(" Add Agent\n              ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        ref: "formBcEdit",
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#add_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcast(false)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-tags" }),
                        _vm._v(" Edit Agent\n              ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        ref: "formBcEditP",
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#password_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcastP()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-tags" }),
                        _vm._v(" Edit Password\n              ")
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row filter-row" }, [
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c("div", { staticClass: "form-group form-focus" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.email,
                          expression: "serverParams.email"
                        }
                      ],
                      staticClass: "form-control floating",
                      attrs: { type: "text" },
                      domProps: { value: _vm.serverParams.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.serverParams,
                            "email",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "focus-label" }, [
                      _vm._v("Email")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c("div", { staticClass: "form-group form-focus" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.name,
                          expression: "serverParams.name"
                        }
                      ],
                      staticClass: "form-control floating",
                      attrs: { type: "text" },
                      domProps: { value: _vm.serverParams.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.serverParams,
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "focus-label" }, [
                      _vm._v("Name")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-success btn-block",
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.searchData($event)
                        }
                      }
                    },
                    [_vm._v("\n              Search\n            ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row agent-grid-row" },
                [
                  _vm.loading
                    ? [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [_c("skeleton", { attrs: { count: 1 } })],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rows.length
                    ? _vm._l(_vm.rows, function(row, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "profile-widget" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "dropdown profile-action" },
                                  [
                                    _vm._m(0, true),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "dropdown-menu dropdown-menu-right"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.detailData(row.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil m-r-5"
                                            }),
                                            _vm._v(" Profile")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.detailDataP(row.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-key m-r-5"
                                            }),
                                            _vm._v(" Set Password")
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "user-name m-t-10 mb-0 text-ellipsis"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(row.first_name) +
                                        " " +
                                        _vm._s(row.last_name) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "user-name m-t-10 mb-0 text-ellipsis"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(row.email) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-white btn-sm m-t-10",
                                    attrs: {
                                      to: "/client/agents/roles?id=" + row.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Roles\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      })
                    : _vm.rows.length < 1 && !_vm.loading
                    ? [
                        _c("div", { staticClass: "col-md-12 text-center" }, [
                          _vm._v("-empty-")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                  _c("span", { staticClass: "footer__row-count__label" }, [
                    _vm._v("Displaying")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.perPage,
                          expression: "serverParams.perPage"
                        }
                      ],
                      staticClass: "select-to-paginasi",
                      staticStyle: { width: "100px" },
                      attrs: { autocomplete: "off", name: "perPageSelect" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.serverParams,
                              "perPage",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.onPerPageChange(_vm.serverParams.perPage)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "10" } }, [
                        _vm._v("10 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "20" } }, [
                        _vm._v("20 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "30" } }, [
                        _vm._v("30 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "40" } }, [
                        _vm._v("40 / page")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "50" } }, [
                        _vm._v("50 / page")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "footer__row-count__label" }, [
                    _vm._v("of " + _vm._s(_vm.totalRecords) + " total records")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12 col-md-6 text-right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      class: { disabled: parseInt(_vm.currentPage) - 1 <= 0 },
                      attrs: { href: "javascript:void(0)", tabindex: "0" },
                      on: {
                        click: function($event) {
                          _vm.onPrevChange(parseInt(_vm.currentPage))
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "chevron left" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Prev")])
                    ]
                  ),
                  _vm._v("\n            page\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentPage,
                        expression: "currentPage"
                      }
                    ],
                    staticStyle: { width: "100px" },
                    attrs: { min: "1", type: "number" },
                    domProps: { value: _vm.currentPage },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.onPageChange(parseInt(_vm.currentPage))
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentPage = $event.target.value
                      }
                    }
                  }),
                  _vm._v(
                    "\n            of " +
                      _vm._s(
                        Math.ceil(_vm.totalRecords / _vm.serverParams.perPage)
                      ) +
                      "\n            "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "footer__navigation__page-btn",
                      class:
                        "btn " +
                        {
                          disabled:
                            parseInt(_vm.currentPage) + 1 >
                            Math.ceil(
                              _vm.totalRecords / _vm.serverParams.perPage
                            )
                        },
                      attrs: { href: "javascript:void(0)", tabindex: "0" },
                      on: {
                        click: function($event) {
                          _vm.onNextChange(parseInt(_vm.currentPage))
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Next")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "chevron right" })
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("form-data", { attrs: { searchData: _vm.searchData } }),
      _vm._v(" "),
      _c("form-password", { attrs: { searchData: _vm.searchData } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "action-icon dropdown-toggle",
        attrs: {
          href: "#",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f8db15c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8db15c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/agents/list.vue
// module id = null
// module chunks = 